import { matchPath } from 'react-router-dom'
import { DEFINED_ROUTE_PATTERNS } from './definedRoutePatterns'
import { KNOWN_MISSING_NAV_ROUTES } from './knownMissingNavRoutes'

export type NavHrefResolution = 'defined' | 'known-missing' | 'orphan'

/** True when pathname matches a registered (non-NotFound) route pattern. */
export function isDefinedRoute(pathname: string): boolean {
  return DEFINED_ROUTE_PATTERNS.some((pattern) =>
    Boolean(matchPath({ path: pattern, end: true }, pathname)),
  )
}

/** Classify a nav/search href against the shared catalog + allowlist. */
export function resolveNavHref(href: string): NavHrefResolution {
  if (Object.prototype.hasOwnProperty.call(KNOWN_MISSING_NAV_ROUTES, href)) {
    return 'known-missing'
  }
  if (isDefinedRoute(href)) {
    return 'defined'
  }
  // Exact static pattern membership (covers redirects like /admin/fin)
  if ((DEFINED_ROUTE_PATTERNS as readonly string[]).includes(href)) {
    return 'defined'
  }
  return 'orphan'
}
